/** @graphql cc **/

import gql from 'graphql-tag';

export const ContextualTitleEmojiQuery = gql`
	query ContextualTitleEmojiQuery($pageAri: ID!, $pageTitle: String!) {
		confluence_contextualTitleEmoji(pageAri: $pageAri, pageTitle: $pageTitle)
	}
`;
